import React, { Fragment } from "react";

export const SettingsPage: React.FC = () => {
  return (
    <Fragment>
      <div>Settings</div>
    </Fragment>
  );
};
